export default __webpack_public_path__ + "static/media/info.818b4585.svg";